import { cn } from '@/utilities/ui'
import React from 'react'
import { NewsCard, CardPostData } from '../NewsCard'

export type Props = {
  posts: CardPostData[]
  locale?: 'de' | 'en'
}

export const CollectionArchive: React.FC<Props> = ({ posts, locale = 'de' }) => {
  return (
    <div className={cn('container mx-auto px-6')}>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {posts?.map((result, index) => {
          if (typeof result === 'object' && result !== null) {
            return (
              <NewsCard
                key={result.slug ?? index}
                doc={result}
                relationTo="posts"
                locale={locale}
              />
            )
          }
          return null
        })}
      </div>
    </div>
  )
}
